import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { IconWrapper } from "../../IconWrapper/index.js";
import { withThemeAndSize } from "../../withThemeAndSize/index.js";
import { cn as clsx } from "../../../helpers/react.js";
import { s } from "../../../style.module-D2YB2asW.js";
const Cell = withThemeAndSize(
  forwardRef(
    ({
      className,
      children,
      label,
      labelClassName,
      criticalClassName,
      criticalIcon,
      criticalSection,
      caption,
      captionClassName,
      showAsterisk = false,
      suggestSection,
      suggestClassName,
      withoutBorder,
      ...rest
    }, ref) => /* @__PURE__ */ jsxs(
      "div",
      {
        ...rest,
        className: clsx(s.modalCell, className, {
          [s.withoutBorder]: withoutBorder
        }),
        ref,
        children: [
          label && /* @__PURE__ */ jsxs("span", { className: clsx(s.label, labelClassName), children: [
            label,
            showAsterisk && /* @__PURE__ */ jsx("span", { className: s.asterisk, children: "*" })
          ] }),
          children,
          (criticalIcon || criticalSection) && /* @__PURE__ */ jsxs("span", { className: clsx(s.criticalSection, criticalClassName), children: [
            criticalIcon && /* @__PURE__ */ jsx(IconWrapper, { size: "md", className: clsx(s.criticalIcon), children: criticalIcon }),
            criticalSection
          ] }),
          caption && /* @__PURE__ */ jsx("span", { className: clsx(s.caption, captionClassName), children: caption }),
          suggestSection && /* @__PURE__ */ jsx("span", { className: clsx(s.suggestSection, suggestClassName), children: suggestSection })
        ]
      }
    )
  )
);
Cell.displayName = "Modal.InputFields.Cell";
export {
  Cell
};
